




























































import Vue from 'vue'
import { mapState } from 'vuex'
import { UserProfile } from '@/types'
import { prepareDataForApi, convertDataFromApi } from '@/utils'
import { app } from '@/firebase'
import PhotoUploader from '@/components/Profile/PhotoUploader.vue'
import EditableLabel from '@/components/Profile/EditableLabel.vue'
import ProfileSection from '@/components/Profile/ProfileSection.vue'
import GdprConsent from '@/components/Common/GDPRConsent.vue'

export type VForm = Vue & { validate: () => boolean }
export interface ProfileEditBasicProp {
    valid: boolean
    displayedUsername: string
    submitted: boolean
    submitting: boolean
}

export default Vue.extend({
    name: 'ProfileEdit',
    components: { PhotoUploader, EditableLabel, ProfileSection, GdprConsent },
    computed: {
        ...mapState('user', ['user']),
        isMobile() {
            return this.$vuetify.breakpoint.mobile
        },
        updatedAtString() {
            const options = { year: 'numeric', month: 'long', day: 'numeric' }
            return this.user.updatedAt && this.user.updatedAt.toLocaleDateString(this.$i18n.locale, options)
        },
    },
    data: (): { profile: UserProfile } & ProfileEditBasicProp => ({
        profile: {
            firstNameEng: '',
            lastNameEng: '',
            photoURL: '',
            gender: 'na',
            residence: '',
            emails: [],
            profArea: [],
            thuMajor: [],
            enrollmentTime: null,
            arriveGermanyAt: null,
            publicContactKeys: [],
        },
        valid: false,
        displayedUsername: '',
        submitted: false,
        submitting: false,
    }),
    watch: {
        user: {
            immediate: true,
            handler: function(currentUser) {
                if (currentUser) {
                    this.displayedUsername = currentUser.name
                    app.functions()
                        .httpsCallable('getUserData')()
                        .then((res) => {
                            // eslint-disable-next-line
                            const { uemail, role, name, updatedAt, ...profileRes } = res.data
                            this.profile = {
                                ...this.profile,
                                ...convertDataFromApi(profileRes),
                            }
                        })
                        .then(() => (this.$refs.form as VForm).validate())
                        .catch((err) => console.log('Error getting user data.', err))
                }
            },
        },
    },
    methods: {
        changePhotoURL(url: string) {
            this.profile.photoURL = url
        },
        setContactPrivacy(key: 'phoneNumber' | 'wechat' | 'github' | 'facebook') {
            if (this.profile.publicContactKeys.includes(key)) {
                this.profile.publicContactKeys = this.profile.publicContactKeys.filter((item) => item !== key)
            } else {
                this.profile.publicContactKeys.push(key)
            }
        },
        onSubmit() {
            if (this.valid) {
                this.submitting = true
                app.functions()
                    .httpsCallable('updateUserProfile')({
                        displayName: this.displayedUsername,
                        photoURL: this.profile.photoURL,
                        profile: prepareDataForApi(this.profile),
                    })
                    .then(() => {
                        this.submitting = false
                        this.submitted = true
                    })
            }
        },
        gotoPath(pathname: string | undefined) {
            this.submitted = false
            if (!!pathname && pathname !== this.$route.name) {
                this.$router.push(pathname)
            }
        },
    },
})
